import clsx from 'clsx';
import { isEmpty } from 'lodash';
import { bool, func, node, object, oneOf, shape, string } from 'prop-types';
import { useTranslation } from 'react-i18next';

import { Icon, StrapiImg } from 'components';

import 'assets/styles/components/base/dialog/_banner.scss';

const Banner = ({
  children,
  type = 'info',
  className = '',
  icon = null,
  image = null,
  dataTestId = null,
  cta = null,
  onDismiss = null
}) => {
  const { t } = useTranslation();

  return (
    <div className={clsx('banner', type, className)} data-test-id={dataTestId}>
      {onDismiss && (
        <button type="button" className="banner-close" onClick={onDismiss}>
          <Icon name="close" />
          <span className="sr-only">{t('buttons.close')}</span>
        </button>
      )}

      <div className="w-full flex flex-wrap gap-3 justify-center items-center lg:justify-between lg:flex-nowrap">
        <div className="flex items-center gap-3 grow">
          {icon && <Icon name={icon.name} iconStyle={icon?.style} classes="banner-icon" />}
          {!icon && image && (
            <div className="max-w-[5rem] h-full rounded-lg overflow-hidden hidden md:block">
              <StrapiImg image={image} className="w-full h-full object-cover" />
            </div>
          )}
          {children}
        </div>

        {!isEmpty(cta) && (
          <a
            className="btn secondary small shrink-0 w-fit h-fit mx-auto lg:mx-initial"
            href={cta.link}
            target={!cta.download ? '_blank' : '_self'}
            rel={!cta.download ? 'noopener noreferrer' : null}
            download={cta.download ?? null}
          >
            {cta.buttonText}
          </a>
        )}
      </div>
    </div>
  );
};

Banner.propTypes = {
  children: node.isRequired,
  type: oneOf(['info', 'error', 'success', 'warning']),
  image: object,
  className: string,
  icon: shape({
    name: string.isRequired,
    style: string
  }),
  dataTestId: string,
  cta: shape({
    link: string.isRequired,
    buttonText: string.isRequired,
    download: bool
  }),
  onDismiss: func
};

export default Banner;
